<script setup>
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import CargarPadron from "@/examples/CargarPadron.vue";
import CargarArchivo from "@/examples/CargarArchivo.vue";
import axios from "axios";
import { BACK_END_URL } from "@/utilities/config";
import { ref } from "vue";
import { computed } from "vue";
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";

const route = useRoute();
const store = useStore();
const configuratorRef = ref(null);
const configuratorRef2 = ref(null);
const loading = ref(false);
const error = ref(null);
const usuarioRol = computed(() => sessionStorage.getItem('usuarioRol'));

const getRoute = () => {
  const routeArr = route.path.split("/");
  return routeArr[1];
};

const isActive = (path) => computed(() => route.path === path);

const redirectToQuickSight = async () => {
  loading.value = true;
  error.value = null;
  
  try {
    const token = sessionStorage.getItem("token");    
    const response = await axios.get(
      `${BACK_END_URL}/quicksight/embed-url`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );   

    if (response.data?.embedUrl) {
      // Open in new tab with noopener for security
      window.open(response.data.embedUrl, "_blank", "noopener,noreferrer");
    } else {
      throw new Error("No valid URL returned from the API");
    }
  } catch (err) {
    console.error("Failed to fetch QuickSight embed URL:", err);
    error.value = err.response?.data?.message || err.message;
    // Optionally show error to user
    alert(`Error: ${error.value}`);
  } finally {
    loading.value = false;
  }
};

const openConfiguratorModal = () => {
  configuratorRef.value?.openModal(); 
};

const openConfiguratorModal2 = () => {
  configuratorRef2.value?.openModal(); 
};
</script>

<template>
  <div id="sidenav-collapse-main" class="collapse navbar-collapse w-auto h-auto h-100 overflow-hidden">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse nav-text="Análisis General del Padrón" :collapse="false" url="#" :aria-controls="''" v-if="usuarioRol === 'administrador' || usuarioRol === 'dueno'"
          collapse-ref="/analisis/pais" :class="{ 'active-item': isActive('/analisis/pais').value }">
          <template #icon>
            <i class="fas fa-chart-pie text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>
        <sidenav-collapse nav-text="Ver Elector" :collapse="false" url="#" :aria-controls="''"
          collapse-ref="/analisis/elector" :class="{ 'active-item': isActive('/analisis/elector').value }">
          <template #icon>
            <i class="fas fa-id-card text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>

        <!--
        <sidenav-collapse collapse-ref="dashboardsExamples" nav-text="Provincias"
          :class="getRoute() === 'dashboards' ? 'active' : ''">
          <template #icon>
            <i class="fas fa-map-marker-alt text-dark text-sm opacity-10 pb-1"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'San José' },
              }" mini-icon="SJ" text="San José" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Alajuela' },
              }" mini-icon="A" text="Alajuela" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Cartago' },
              }" mini-icon="C" text="Cartago" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Heredia' },
              }" mini-icon="H" text="Heredia" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Guanacaste' },
              }" mini-icon="G" text="Guanacaste" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Puntarenas' },
              }" mini-icon="P" text="Puntarenas" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Limón' },
              }" mini-icon="L" text="Limón" />
              <sidenav-item :to="{
                name: 'Análisis Provincia',
                params: { province: 'Extranjeros' },
              }" mini-icon="E" text="Extranjeros" />
            </ul>
          </template>
        </sidenav-collapse>-->

      </li>
      <li v-if="usuarioRol === 'administrador' || usuarioRol === 'dueno'" class="nav-item">  
        <sidenav-collapse 
          nav-text="Datos PLN" 
          :collapse="false" 
          style="cursor: pointer" 
          @click="redirectToQuickSight"
        >
          <template #icon>
            <i class="fas fa-chart-bar text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>
      </li>


      <hr class="mt-3 horizontal dark" />

      <li class="nav-item">
        <!-- nav links de usuarios -->
        <sidenav-collapse nav-text="Usuarios" :collapse="false" url="#" :aria-controls="''" v-if="usuarioRol === 'administrador' || usuarioRol === 'dueno'"
          collapse-ref="/usuarios/usuarios-organizacion" :class="{
            'active-item': isActive('/usuarios/usuarios-organizacion').value,
          }">
          <template #icon>
            <i class="fas fa-users text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>

        <!-- nav links de qr -->
        <sidenav-collapse nav-text="Electores" :collapse="false" url="#" :aria-controls="''" collapse-ref="/inicio"
          :class="{ 'active-item': isActive('/inicio').value }">
          <template #icon>
            <i class="fas fa-clipboard-list text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>

        <!-- nav links de registro de elector -->
        <sidenav-collapse nav-text="Registro Elector" :collapse="false" url="#" :aria-controls="''"
          collapse-ref="/elector" :class="{ 'active-item': isActive('/elector').value }">
          <template #icon>
            <i class="fas fa-user-plus text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>
      </li>

      <hr class="mt-3 horizontal dark" />

      <!-- nav links de cargar padron -->      
      <li class="nav-item" v-if="usuarioRol === 'administrador' || usuarioRol === 'dueno'">
        <sidenav-collapse nav-text="Cargar Padron Electoral" :collapse="false" url="#" @click="openConfiguratorModal"
          style="cursor: pointer">
          <template #icon>
            <i class="fas fa-file-import text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="usuarioRol === 'administrador' || usuarioRol === 'dueno'">
        <sidenav-collapse nav-text="Cargar Masiva" :collapse="false" url="#" @click="openConfiguratorModal2"
          style="cursor: pointer">
          <template #icon>
            <i class="fas fa-upload text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="usuarioRol === 'administrador' || usuarioRol === 'dueno'">
      <sidenav-collapse nav-text="Historial de Cargas" :collapse="false" url="#" :aria-controls="''"
          collapse-ref="/configuracion/logs" :class="{ 'active-item': isActive('/configuracion/logs').value }">
          <template #icon>
            <i class="fas fa-history text-sm pt-0 pb-1" :class="store.state.sidebarType === 'bg-default' || store.state.darkMode
                ? 'text-white'
                : 'text-dark'
              "></i>
          </template>
      </sidenav-collapse>
    </li>
    </ul>
    <CargarPadron ref="configuratorRef" />
    <CargarArchivo ref="configuratorRef2" />

  </div>
</template>

<style>
.active-item {
  background-color: #e3e3e9;
  border-radius: 5px;
  font-weight: 600 !important;
}

.navbar-vertical.navbar-expand-xs {
  overflow-y: auto !important;
}
</style>
